import { render, staticRenderFns } from "./InvitationLaboratory.vue?vue&type=template&id=2cad61fc&scoped=true&"
import script from "./InvitationLaboratory.vue?vue&type=script&lang=js&"
export * from "./InvitationLaboratory.vue?vue&type=script&lang=js&"
import style0 from "./InvitationLaboratory.vue?vue&type=style&index=0&id=2cad61fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cad61fc",
  null
  
)

export default component.exports